import { Box, Center, HStack, Icon, Stack, StackDivider, Text, VStack, useBreakpointValue } from '@chakra-ui/react';
import { FaInstagram, FaYoutube } from 'react-icons/fa';

export const Footer = () => {
	return (
		<Center w="full" bg={'gray.900'} color={'gray.200'} py={16} fontFamily={'notosans'}>
			<VStack maxW={'6xl'} borderStyle={'solid'} borderColor={'gray.700'}>
				<Center w="full" py={4}>
					<Stack direction={'row'} spacing={6}>
						<Center
							rounded={'full'}
							w={16}
							h={16}
							bg="red.600"
							cursor={'pointer'}
							as={'a'}
							href="https://www.youtube.com/@mal_mal_"
							target="_blank"
							alignItems={'center'}
							justifyContent={'center'}
						>
							<Icon as={FaYoutube} color="white" boxSize={10} />
						</Center>
						<Center
							rounded={'full'}
							w={16}
							h={16}
							bgGradient="linear(to-br, #FEDA75, #FA7E1E, #D62976, #962FBF, #4F5BD5)"
							cursor={'pointer'}
							as={'a'}
							href="https://www.instagram.com/chaggebi"
							target="_blank"
						>
							<Icon as={FaInstagram} boxSize={10} />
						</Center>
						<Center
							rounded={'full'}
							w={16}
							h={16}
							cursor={'pointer'}
							as={'a'}
							href="https://grafolio.naver.com/chaggebi"
							target="_blank"
							bg="#00D084"
							alignItems={'center'}
							justifyContent={'center'}
						>
							<Box boxSize={10}>
								<svg width="100%" height="100%" viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path
										fillRule="evenodd"
										clipRule="evenodd"
										d="M139.691 39.6256C130.588 26.4406 117.297 16.7185 101.975 12.0368C86.652 7.35506 70.1969 7.98854 55.2796 13.8344C40.3623 19.6803 27.8581 30.3955 19.7962 44.2412C11.7342 58.087 8.58754 74.2508 10.8668 90.1097C13.1461 105.969 20.7176 120.592 32.3526 131.607C43.9875 142.622 59.0033 149.382 74.9632 150.79C90.923 152.198 106.89 148.172 120.274 139.364C133.658 130.557 143.673 117.485 148.694 102.27L148.518 102.212L149 101.377L92.1217 68.5379L77.7701 93.3954L105.661 109.498C99.1061 114.711 90.8077 117.825 81.782 117.825C60.5754 117.825 43.3841 100.634 43.3841 79.4269C43.3841 58.2203 60.5754 41.029 81.782 41.029C94.9371 41.029 106.547 47.6444 113.467 57.73L139.691 39.6256Z"
										fill="white"
									/>
								</svg>
							</Box>
						</Center>
						<Center
							rounded={'full'}
							w={16}
							h={16}
							cursor={'pointer'}
							as={'a'}
							href="https://twitter.com/2malmal2"
							target="_blank"
							bg="black"
							alignItems={'center'}
							justifyContent={'center'}
						>
							<Box boxSize={10}>
								<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="180 200 1100 1100" version="1.1">
									<path
										d="M 304.292 302.750 C 307.279 307.012, 376.455 407.700, 458.017 526.500 C 539.579 645.300, 615.016 755.165, 625.656 770.645 C 636.295 786.125, 645 799.101, 645 799.481 C 645 799.861, 641.038 804.746, 636.196 810.336 C 631.354 815.926, 617.715 831.750, 605.889 845.500 C 594.062 859.250, 574.125 882.425, 561.584 897 C 549.044 911.575, 526.982 937.225, 512.557 954 C 498.133 970.775, 472.194 1000.934, 454.915 1021.020 C 401.474 1083.146, 393.762 1092.119, 353.081 1139.500 C 331.359 1164.800, 310.529 1188.990, 306.793 1193.256 C 303.057 1197.522, 300 1201.460, 300 1202.006 C 300 1202.647, 313.644 1203, 338.441 1203 L 376.881 1203 419.142 1153.750 C 442.386 1126.662, 465.315 1100, 470.095 1094.500 C 480.432 1082.608, 559.262 990.885, 565.888 983.040 C 568.425 980.037, 572.110 975.762, 574.077 973.540 C 576.045 971.318, 591.554 953.300, 608.542 933.500 C 625.529 913.700, 639.895 897.015, 640.464 896.422 C 641.034 895.830, 650.027 885.367, 660.449 873.172 C 670.871 860.978, 679.720 851, 680.113 851 C 680.507 851, 734.043 928.513, 799.084 1023.250 C 864.124 1117.987, 918.500 1197.178, 919.920 1199.229 L 922.500 1202.957 1054.357 1202.979 C 1162.791 1202.996, 1186.125 1202.767, 1185.710 1201.687 C 1185.270 1200.539, 1122.096 1108.393, 960.025 872.500 C 843.352 702.684, 827.838 679.864, 828.283 678.706 C 828.715 677.580, 844.607 658.993, 949.085 537.417 C 967.007 516.563, 991.712 487.800, 1003.985 473.500 C 1016.258 459.200, 1028.650 444.800, 1031.522 441.500 C 1034.394 438.200, 1049.496 420.650, 1065.082 402.500 C 1080.667 384.350, 1107.162 353.510, 1123.960 333.967 C 1140.757 314.424, 1155.118 297.662, 1155.872 296.717 C 1157.165 295.100, 1154.969 295, 1118.199 295 L 1079.154 295 1061.788 315.250 C 1038.675 342.200, 996.894 390.799, 985.030 404.532 C 979.789 410.600, 973.250 418.226, 970.500 421.478 C 967.750 424.730, 962.324 431.015, 958.443 435.445 C 954.562 439.875, 935.003 462.625, 914.978 486 C 894.954 509.375, 878.296 528.725, 877.960 529 C 877.625 529.275, 873.334 534.252, 868.425 540.061 C 859.839 550.221, 851.101 560.391, 811.027 606.865 C 793.437 627.265, 792.535 628.141, 791.052 626.266 C 790.199 625.186, 738.650 550.213, 676.500 459.661 L 563.500 295.021 431.181 295.010 L 298.862 295 304.292 302.750 M 407.565 356.742 C 408.559 358.259, 433.281 393.700, 462.504 435.500 C 517.927 514.776, 735.717 826.486, 875.781 1027 C 920.539 1091.075, 957.705 1144.066, 958.373 1144.758 C 959.327 1145.747, 972.359 1145.961, 1019.267 1145.758 L 1078.947 1145.500 922.776 922 C 836.881 799.075, 712.520 621.100, 646.418 526.500 L 526.232 354.500 465.996 354.242 L 405.760 353.984 407.565 356.742"
										stroke="none"
										fill="#fafafa"
										fillRule="evenodd"
									/>
									<path
										d="M 0 741.501 L 0 1483.001 741.750 1482.751 L 1483.500 1482.500 1483.751 741.250 L 1484.001 0 742.001 0 L 0 0 0 741.501 M 0.497 742 C 0.497 1149.825, 0.611 1316.662, 0.750 1112.750 C 0.889 908.837, 0.889 575.162, 0.750 371.250 C 0.611 167.337, 0.497 334.175, 0.497 742 M 304.292 302.750 C 307.279 307.012, 376.455 407.700, 458.017 526.500 C 539.579 645.300, 615.016 755.165, 625.656 770.645 C 636.295 786.125, 645 799.101, 645 799.481 C 645 799.861, 641.038 804.746, 636.196 810.336 C 631.354 815.926, 617.715 831.750, 605.889 845.500 C 594.062 859.250, 574.125 882.425, 561.584 897 C 549.044 911.575, 526.982 937.225, 512.557 954 C 498.133 970.775, 472.194 1000.934, 454.915 1021.020 C 401.474 1083.146, 393.762 1092.119, 353.081 1139.500 C 331.359 1164.800, 310.529 1188.990, 306.793 1193.256 C 303.057 1197.522, 300 1201.460, 300 1202.006 C 300 1202.647, 313.644 1203, 338.441 1203 L 376.881 1203 419.142 1153.750 C 442.386 1126.662, 465.315 1100, 470.095 1094.500 C 480.432 1082.608, 559.262 990.885, 565.888 983.040 C 568.425 980.037, 572.110 975.762, 574.077 973.540 C 576.045 971.318, 591.554 953.300, 608.542 933.500 C 625.529 913.700, 639.895 897.015, 640.464 896.422 C 641.034 895.830, 650.027 885.367, 660.449 873.172 C 670.871 860.978, 679.720 851, 680.113 851 C 680.507 851, 734.043 928.513, 799.084 1023.250 C 864.124 1117.987, 918.500 1197.178, 919.920 1199.229 L 922.500 1202.957 1054.357 1202.979 C 1162.791 1202.996, 1186.125 1202.767, 1185.710 1201.687 C 1185.270 1200.539, 1122.096 1108.393, 960.025 872.500 C 843.352 702.684, 827.838 679.864, 828.283 678.706 C 828.715 677.580, 844.607 658.993, 949.085 537.417 C 967.007 516.563, 991.712 487.800, 1003.985 473.500 C 1016.258 459.200, 1028.650 444.800, 1031.522 441.500 C 1034.394 438.200, 1049.496 420.650, 1065.082 402.500 C 1080.667 384.350, 1107.162 353.510, 1123.960 333.967 C 1140.757 314.424, 1155.118 297.662, 1155.872 296.717 C 1157.165 295.100, 1154.969 295, 1118.199 295 L 1079.154 295 1061.788 315.250 C 1038.675 342.200, 996.894 390.799, 985.030 404.532 C 979.789 410.600, 973.250 418.226, 970.500 421.478 C 967.750 424.730, 962.324 431.015, 958.443 435.445 C 954.562 439.875, 935.003 462.625, 914.978 486 C 894.954 509.375, 878.296 528.725, 877.960 529 C 877.625 529.275, 873.334 534.252, 868.425 540.061 C 859.839 550.221, 851.101 560.391, 811.027 606.865 C 793.437 627.265, 792.535 628.141, 791.052 626.266 C 790.199 625.186, 738.650 550.213, 676.500 459.661 L 563.500 295.021 431.181 295.010 L 298.862 295 304.292 302.750 M 407.565 356.742 C 408.559 358.259, 433.281 393.700, 462.504 435.500 C 517.927 514.776, 735.717 826.486, 875.781 1027 C 920.539 1091.075, 957.705 1144.066, 958.373 1144.758 C 959.327 1145.747, 972.359 1145.961, 1019.267 1145.758 L 1078.947 1145.500 922.776 922 C 836.881 799.075, 712.520 621.100, 646.418 526.500 L 526.232 354.500 465.996 354.242 L 405.760 353.984 407.565 356.742"
										stroke="none"
										fill="#040404"
										fillRule="evenodd"
									/>
								</svg>
							</Box>
						</Center>
					</Stack>
				</Center>

				<Center w="full" py={4}>
					<VStack>
						<Text color={'white'} fontWeight={400} lineHeight={1.2} fontSize={useBreakpointValue({ base: 'md', md: 'lg' })}>
							Chaggebi® © 2024 MALMAL Studio. All Rights Reserved.
						</Text>

						<HStack spacing={4} divider={<StackDivider borderColor={'gray'} />}>
							<Text
								color={'gray'}
								fontWeight={400}
								lineHeight={1.2}
								fontSize={useBreakpointValue({ base: 'sm', md: 'md' })}
								as={'a'}
								href="/privacy"
								target="_blank"
							>
								개인정보 처리 방침
							</Text>
							<Text
								color={'gray'}
								fontWeight={400}
								lineHeight={1.2}
								fontSize={useBreakpointValue({ base: 'sm', md: 'md' })}
								as={'a'}
								href="/terms-of-service"
								target="_blank"
							>
								이용약관
							</Text>
							<Text
								color={'gray'}
								fontWeight={400}
								lineHeight={1.2}
								fontSize={useBreakpointValue({ base: 'sm', md: 'md' })}
								as={'a'}
								href="/oss-notice"
								target="_blank"
							>
								OSS Notice
							</Text>
						</HStack>

						<Text color={'white'} fontWeight={900} lineHeight={1.2} fontSize={useBreakpointValue({ base: 'xl', md: '4xl' })}>
							MALMAL Studio
						</Text>
					</VStack>
				</Center>
			</VStack>
		</Center>
	);
};
